module.exports = __webpack_public_path__ + "static/media/background.eb7b9cbe.png";